export function addLocationCollection(collection, ...locationSummaries) {
  if (!collection) {
    return null;
  }

  const summaries = locationSummaries.filter(
    (summary) => summary && Object.keys(summary).length > 0,
  );

  if (!summaries.length) {
    return collection;
  }

  const names = new Set(['locations', ...summaries.map((summary) => summary.name)]);

  return [
    ...summaries,
    ...collection.filter((item) => !names.has(item.name)),
  ];
}
